export const ROLES = [
  "Admin",
  "Entwickler*in",
  "Freigeber*in",
  "Kollegium",
  "GF",
  "Controlling",
];
